export default __webpack_public_path__ + "static/media/Laboratorioambientea.d8c70d2b.png";